import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const pulsate = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Dot = styled.span<{ delay: number }>`
  width: 4px;
  height: 4px;
  margin: 0 4px;
  background-color: currentColor;
  border-radius: 50%;
  display: inline-block;
  animation: ${pulsate} 1s infinite ease-in-out both;
  animation-delay: ${(props) => props.delay}s;
`;

export const SingleDotContainer = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SingleDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: currentColor;
  border-radius: 50%;
  display: inline-block;
  animation: ${pulsate} 1s infinite ease-in-out;
`;
